import React from 'react';
import Banner from './Banner';
import ContactSection from './ContactSection';
import FeaturesSection from './FeaturesSection';
import ServicesSection from './ServicesSection';
import VideoSection from './VideoSection';

const ThreeDPrintingPage: React.FC = () => {
  return (
    <article
      id="post-5002"
      className="post_item_single post_type_page post-5002 page type-page status-publish hentry"
    >
      <div className="post_content entry-content">
        <div
          data-elementor-type="wp-page"
          data-elementor-id="5002"
          className="elementor elementor-5002"
        >
          <Banner />
          <FeaturesSection />
          {/* <VideoSection /> */}
          {/* <ServicesSection /> */}
          <ContactSection />
        </div>
      </div>
    </article>
  );
};

export default ThreeDPrintingPage;
